import { FiChevronRight } from "react-icons/fi";
import { Text } from "~/components/Text";
import GoldenButterImage from "~/images/golden-butter.png";

type ClubHeaderProps = {
  name: string;
  hostName?: string;
  otherHostCount?: number;
  premium?: boolean;
  onSelectHost: () => void;
};

export function ClubHeader({
  name,
  hostName,
  otherHostCount = 0,
  premium = false,
  onSelectHost,
}: ClubHeaderProps) {
  const hostLabel = hostName
    ? otherHostCount > 0
      ? `Hosted by ${hostName} and ${otherHostCount === 1 ? "1 other" : `${otherHostCount} others`}`
      : `Hosted by ${hostName}`
    : null;

  return (
    <header className="flex flex-col">
      {hostLabel && (
        <button
          type="button"
          onClick={onSelectHost}
          className="group mb-2 inline-flex items-center gap-1 self-start hover:opacity-80"
        >
          <Text as="span" variant="secondary" size="sm" weight="bold">
            {hostLabel}
          </Text>
          <FiChevronRight
            size={16}
            className="text-butter-green transition-transform group-hover:translate-x-0.5"
            aria-hidden
          />
        </button>
      )}

      <Text variant="primary" size="xl" as="h1">
        {premium ? <PremiumName name={name} /> : name}
      </Text>
    </header>
  );
}

function PremiumName({ name }: { name: string }) {
  const trimmed = name.trimEnd();
  const lastSpace = trimmed.lastIndexOf(" ");
  const head = lastSpace >= 0 ? trimmed.slice(0, lastSpace + 1) : "";
  const tail = lastSpace >= 0 ? trimmed.slice(lastSpace + 1) : trimmed;

  return (
    <>
      {head}
      <span className="whitespace-nowrap">
        {tail}
        <img
          src={GoldenButterImage}
          alt=""
          aria-hidden
          className="ml-2 inline-block h-3 w-3 align-text-top sm:h-4 sm:w-4 lg:h-5 lg:w-5"
        />
      </span>
    </>
  );
}
